var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.17,220a28.27,28.27,0,0,1-29.72,0,28.26,28.26,0,1,1,29.72,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,192.7a8.6,8.6,0,1,1-8.6-8.6A8.6,8.6,0,0,1,94.91,192.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.17,216.42V220a28.27,28.27,0,0,1-29.72,0v-3.54a14.86,14.86,0,0,1,29.72,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.42,102.63a3.16,3.16,0,0,1,3.3,0c.28.16.56.33.85.48s.58.3.88.44a3.16,3.16,0,0,1,1.84,2.73l.12,4.07L83.65,110l-.13-4.06a3.16,3.16,0,0,1,1.66-2.85,18.07,18.07,0,0,0,1.68-1,3.15,3.15,0,0,1,3.29-.21l3.57,1.92L100,92.05l-3.57-1.92a3.13,3.13,0,0,1-1.64-2.85,18.72,18.72,0,0,0-.07-2,3.16,3.16,0,0,1,1.46-3l3.45-2.14L92.63,69,89.16,71.1a3.14,3.14,0,0,1-3.29,0c-.27-.17-.56-.33-.84-.48l-.87-.44a3.17,3.17,0,0,1-1.85-2.74l-.12-4.07L69,63.76l.13,4.05a3.13,3.13,0,0,1-1.66,2.85,19.6,19.6,0,0,0-1.68,1,3.15,3.15,0,0,1-3.29.21L58.88,70,52.62,81.68l3.57,1.91a3.13,3.13,0,0,1,1.64,2.86,18.72,18.72,0,0,0,.07,2,3.16,3.16,0,0,1-1.46,3L53,93.52l7,11.25Zm3.32-20.89a10.84,10.84,0,1,1,4.43,14.68A10.85,10.85,0,0,1,66.74,81.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,340.79a2.23,2.23,0,0,1,2.05-1.08l.68,0,.69,0a2.21,2.21,0,0,1,2,1.08l1.42,2.47,8-4.64-1.42-2.47a2.19,2.19,0,0,1,.08-2.31,12.71,12.71,0,0,0,.69-1.19,2.2,2.2,0,0,1,2-1.22h2.84v-9.28h-2.84a2.21,2.21,0,0,1-2-1.22,12.71,12.71,0,0,0-.69-1.19,2.21,2.21,0,0,1-.08-2.32l1.42-2.46-8-4.64-1.43,2.48a2.18,2.18,0,0,1-2,1.07l-.69,0-.68,0a2.22,2.22,0,0,1-2.05-1.08l-1.42-2.47-8,4.64,1.42,2.46a2.19,2.19,0,0,1-.08,2.31,12.88,12.88,0,0,0-.69,1.2,2.21,2.21,0,0,1-2,1.22h-2.84v9.28h2.84a2.21,2.21,0,0,1,2,1.22q.32.62.69,1.2a2.19,2.19,0,0,1,.08,2.31l-1.42,2.46,8,4.64Zm-4.87-14a7.6,7.6,0,1,1,7.6,7.6A7.61,7.61,0,0,1,423.44,326.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.34,126.21a2.21,2.21,0,0,1,1.08,2c0,.23,0,.46,0,.69s0,.46,0,.68a2.2,2.2,0,0,1-1.08,2l-2.46,1.43,4.63,8L102,139.7a2.19,2.19,0,0,1,2.31.08,12.88,12.88,0,0,0,1.2.69,2.2,2.2,0,0,1,1.21,2v2.84H116v-2.84a2.21,2.21,0,0,1,1.22-2q.61-.32,1.2-.69a2.19,2.19,0,0,1,2.31-.08l2.46,1.42,4.64-8-2.48-1.43a2.21,2.21,0,0,1-1.07-2c0-.23,0-.46,0-.68s0-.46,0-.69a2.21,2.21,0,0,1,1.08-2l2.47-1.43-4.64-8-2.45,1.42a2.21,2.21,0,0,1-2.32-.08,11.7,11.7,0,0,0-1.2-.69,2.21,2.21,0,0,1-1.22-2V112.6H106.7v2.84a2.2,2.2,0,0,1-1.22,2q-.62.31-1.2.69a2.19,2.19,0,0,1-2.31.08l-2.46-1.42-4.63,8Zm14-4.88a7.6,7.6,0,1,1-7.6,7.61A7.61,7.61,0,0,1,111.34,121.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.64,
    y: 55.41,
    width: 55.45,
    height: 67.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.97,
    y: 61.55,
    width: 42.78,
    height: 54.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.97,
    y: 61.55,
    width: 1.67,
    height: 54.98,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.08,
    y: 55.41,
    width: 1.67,
    height: 67.26,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.31,
    y: 74.26,
    width: 10.09,
    height: 30.05,
    transform: "translate(848.71 178.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.3,84.35H406.41V68.63H434.3Zm-26.89-1H433.3V69.63H407.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.64,
    y: 221.15,
    width: 55.45,
    height: 67.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.97,
    y: 227.29,
    width: 42.78,
    height: 54.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.97,
    y: 227.29,
    width: 1.67,
    height: 54.98,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.08,
    y: 221.15,
    width: 1.67,
    height: 67.26,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.31,
    y: 240.01,
    width: 10.09,
    height: 30.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.3,250.09H406.41V234.37H434.3Zm-26.89-1H433.3V235.37H407.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.64,
    y: 138.58,
    width: 55.45,
    height: 67.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.97,
    y: 144.72,
    width: 42.78,
    height: 54.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.97,
    y: 144.72,
    width: 1.67,
    height: 54.98,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.08,
    y: 138.58,
    width: 1.67,
    height: 67.26,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.22,
    y: 158.93,
    width: 8.64,
    height: 21.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.46,187.77H408.24V171.71h24.22Zm-23.22-1h22.22V172.71H409.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.71,308.54V453H159V308.54Zm7.93,53.54h71.47v37.61H79.64Zm0-46.56h71.47v37.61H79.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.79,
    y: 308.54,
    width: 34.92,
    height: 144.45,
    transform: "translate(108.5 761.54) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.13,
    y: 315.52,
    width: 16.98,
    height: 37.6,
    transform: "translate(285.23 668.64) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,444.3H79.27V407.7H151Zm-71-.75h70.27v-35.1H80Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.08,
    y: 418.16,
    width: 14.11,
    height: 7.14,
    transform: "translate(236.26 843.46) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.39,425.14H106.53v-6.81h14.86Zm-14.11-.75h13.36v-5.31H107.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.13,
    y: 362.08,
    width: 16.98,
    height: 37.6,
    transform: "translate(285.23 761.77) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.68,397.18S80.84,367.9,87.36,358,106,337.08,106,337.08,105.73,382.23,72.68,397.18Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,396.68a140.59,140.59,0,0,0,7.44-14.19,98.59,98.59,0,0,1,4.05-15.4c0-.09.16,0,.14.06-1.08,4.62-2.34,9.21-3.48,13.82,3.29-7.13,6.42-14.34,10.34-21.08a45.16,45.16,0,0,1,3.78-9.37c0-.09.19,0,.15.05a60.33,60.33,0,0,0-2.55,7,70.53,70.53,0,0,1,6.2-8.56c.14-.17.43,0,.29.19-5.25,6.7-8.87,14.31-12.31,22a117.46,117.46,0,0,0,10.23-12.79s.1,0,.07.05a104.81,104.81,0,0,1-11,14.21c-2.51,5.65-5,11.32-8,16.69,6-5.05,10.58-11.6,15.14-17.91.1-.14.32,0,.22.15-4.55,6.93-9.27,13.45-15.83,18.58a71.54,71.54,0,0,1-4.38,6.85A.35.35,0,0,1,73.27,396.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.13,397.22s14.67-27,10.41-53.18-8.82-35.5-8.82-35.5S49.66,349.26,71.13,397.22Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.11,354.77a128.45,128.45,0,0,0,5.66,21.81c0-9.61.23-19.22.49-28.82a74.19,74.19,0,0,1-2.77-17.9c0-.17.26-.16.27,0a101.22,101.22,0,0,0,2.57,15.4q.33-11.89.77-23.78a.11.11,0,0,1,.21,0c0,12.38,0,24.76-.08,37.14a98.64,98.64,0,0,0,4.22-14.71c0-.05.09,0,.09,0a57.48,57.48,0,0,1-4.33,16.74c-.06,7.92-.14,15.83-.32,23.74C74.37,376,77,367.86,77.74,359a.1.1,0,0,1,.19,0c-.2,9.81-2.73,19.76-6,29a.67.67,0,0,1-.16.23c-.08,2.89-.16,5.79-.26,8.68a.32.32,0,0,1-.64,0q-.16-8.88-.14-17.76A79.46,79.46,0,0,1,65,354.79C65,354.72,65.1,354.7,65.11,354.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.12,350.6a50.59,50.59,0,0,1,1,7.13c0,.08-.12.09-.14,0a50.26,50.26,0,0,1-1.2-7.11C65.78,350.45,66.08,350.42,66.12,350.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,330.86c0-.08.14-.05.14,0a18.59,18.59,0,0,1-.73,4.92.1.1,0,0,1-.2-.06C74.22,334.12,74.42,332.49,74.69,330.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.78,397.22S66.37,369,58.29,355s-21.5-21.15-21.5-21.15S42.2,383.56,65.78,397.22Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,373.12A105.59,105.59,0,0,0,62,387c-1.61-5.76-3.49-11.43-5.6-17-4.53-4-9-8.09-11.81-13.53a.08.08,0,0,1,.14-.08c3,4.82,7,8.67,11.19,12.38a218.21,218.21,0,0,0-11.25-24.51.18.18,0,0,1,.31-.18,131.44,131.44,0,0,1,7,12.86c-.75-3-1.36-6.09-2.14-9.08a.07.07,0,0,1,.13,0,50.84,50.84,0,0,1,3.32,12,143.74,143.74,0,0,1,7.12,19.28c-.21-4.22-.47-8.43-.91-12.64,0-.08.13-.1.14,0a68.37,68.37,0,0,1,1.23,14.2q1.74,6.3,2.93,12.73c0,.11-.15.17-.18.05-.43-1.8-.91-3.58-1.4-5.35,0,0-.06,0-.09,0A57.06,57.06,0,0,1,51,373.15,0,0,0,1,1,51,373.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67,350.19c.9,1,1.73,2,2.6,3a23.92,23.92,0,0,1,2.33,2.72.05.05,0,0,1-.07.07,14.12,14.12,0,0,1-2.69-2.66,22.58,22.58,0,0,1-2.3-3C41.49,350.21,41.61,350.12,41.67,350.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,399.29l-1,13.35L84.74,453H58l-3.07-40.36-1-13.35h35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,399.29l-.62,8.11-33.63,1.35-.72-9.46h35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.48,
    y: 392.74,
    width: 39.73,
    height: 10.24,
    transform: "translate(142.69 795.71) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.79 453 90.09 452.75 143.4 452.67 250 452.5 356.61 452.66 409.91 452.75 463.21 453 409.91 453.24 356.61 453.33 250 453.5 143.4 453.33 90.09 453.24 36.79 453",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.74,
    y: 117.24,
    width: 402.34,
    height: 269.18,
    rx: 12.89,
    transform: "translate(499.74 3.92) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.99,
    y: 78.82,
    width: 246.15,
    height: 346.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.81,
    y: 37.71,
    width: 4.18,
    height: 58.58,
    rx: 1.25,
    transform: "translate(314.91 -180.9) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.91,
    cy: 438.68,
    r: 7.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.99,
    y: 78.82,
    width: 246.15,
    height: 346.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.4,
    y: 262.94,
    width: 105.25,
    height: 15.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.66,267.57a.22.22,0,0,1,.2-.2.21.21,0,0,1,.21.2v3.26a1.94,1.94,0,1,0,3.88,0v-3.26a.21.21,0,0,1,.2-.2.21.21,0,0,1,.21.2v3.26a2.35,2.35,0,1,1-4.7,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,272.33a.19.19,0,0,1,.28,0,2.15,2.15,0,0,0,1.25.47,1.24,1.24,0,0,0,.77-.25.56.56,0,0,0,0-1,1.93,1.93,0,0,0-.86-.3h0a2.38,2.38,0,0,1-.92-.32.84.84,0,0,1-.44-.72,1,1,0,0,1,.44-.8,1.72,1.72,0,0,1,1-.27,2.19,2.19,0,0,1,1.21.44.21.21,0,0,1,.06.28.22.22,0,0,1-.28.06,1.73,1.73,0,0,0-1-.41,1.22,1.22,0,0,0-.77.23.6.6,0,0,0-.26.47.47.47,0,0,0,.23.4,1.87,1.87,0,0,0,.83.28h0a2.77,2.77,0,0,1,1,.34,1,1,0,0,1,.46.82,1.06,1.06,0,0,1-.46.83,1.73,1.73,0,0,1-1,.32,2.55,2.55,0,0,1-1.51-.58A.19.19,0,0,1,218,272.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,271.16a2,2,0,0,1,2-2,2,2,0,0,1,2,1.89h0v0a.18.18,0,0,1-.2.18H222.5a1.59,1.59,0,0,0,1.57,1.56,1.51,1.51,0,0,0,1.31-.74.2.2,0,0,1,.27-.06.21.21,0,0,1,.06.28,1.93,1.93,0,0,1-1.64.92A2,2,0,0,1,222.1,271.16Zm.42-.33h3.08a1.57,1.57,0,0,0-1.53-1.32A1.59,1.59,0,0,0,222.52,270.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.26,269.32a.2.2,0,0,1,.21-.2.2.2,0,0,1,.19.2v.9a.53.53,0,0,1,.06-.1,2,2,0,0,1,1.62-1,.2.2,0,1,1,0,.4,1.48,1.48,0,0,0-1.18.67,3.42,3.42,0,0,0-.48.94.11.11,0,0,0,0,.07V273a.19.19,0,0,1-.19.2.2.2,0,0,1-.21-.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.8,270.77a1.25,1.25,0,0,0-1.25-1.25,1.28,1.28,0,0,0-1.26,1.25V273a.3.3,0,0,1,0,.1.21.21,0,0,1-.15.07h0a.21.21,0,0,1-.13-.11v-3.75a.2.2,0,1,1,.39,0v.39a1.65,1.65,0,0,1,2.91,1.06V273a.2.2,0,0,1-.4,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.39,269.31V273a.2.2,0,1,1-.4,0v-.61a1.88,1.88,0,0,1-1.53.81,2,2,0,0,1,0-4.06,1.88,1.88,0,0,1,1.53.79v-.6a.2.2,0,0,1,.4,0Zm-.4,1.84a1.53,1.53,0,1,0-1.53,1.63A1.59,1.59,0,0,0,239,271.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92,270.77a1.26,1.26,0,1,0-2.51,0v2.28c0,.05-.06.08-.1.1a.17.17,0,0,1-.1,0h-.06l0,0,0,0,0,0s0,0,0,0v0h0a0,0,0,0,0,0,0v0h0v-2.22a1.25,1.25,0,1,0-2.5,0V273a.18.18,0,0,1-.09.16l0,0h-.09a.2.2,0,0,1-.16-.15v-3.72a.2.2,0,0,1,.19-.19.19.19,0,0,1,.2.19v.39a1.64,1.64,0,0,1,2.7.29,1.68,1.68,0,0,1,1.46-.87,1.65,1.65,0,0,1,1.65,1.65V273a.19.19,0,0,1-.2.19.2.2,0,0,1-.19-.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,271.16a2,2,0,0,1,2-2,2,2,0,0,1,2,1.89h0v0a.18.18,0,0,1-.2.18H249.1a1.6,1.6,0,0,0,1.57,1.56A1.51,1.51,0,0,0,252,272a.2.2,0,0,1,.27-.06.22.22,0,0,1,.07.28,2,2,0,0,1-1.65.92A2,2,0,0,1,248.7,271.16Zm.42-.33h3.08a1.57,1.57,0,0,0-1.53-1.32A1.59,1.59,0,0,0,249.12,270.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,269.29a1.46,1.46,0,1,1-1.46-1.46A1.46,1.46,0,0,1,204.26,269.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.33,273.3h-5.05a2.53,2.53,0,0,1,5.05,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.4,
    y: 285.08,
    width: 105.25,
    height: 15.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,290.9a13.07,13.07,0,0,1-3.6,3.61,12,12,0,0,1,1.62-2A12.54,12.54,0,0,1,215.14,290.9Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,290.9a12.54,12.54,0,0,1,2,1.63,12,12,0,0,1,1.62,2,13.07,13.07,0,0,1-3.6-3.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.89,292.71a13.13,13.13,0,0,1-5.1,0,11,11,0,0,1,2.55-.25A11.61,11.61,0,0,1,215.89,292.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.34,290.16a13.08,13.08,0,0,1,0,5.09,13.08,13.08,0,0,1,0-5.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.93,290.9a13.44,13.44,0,0,1-3.6,3.61,12,12,0,0,1,1.62-2A12.54,12.54,0,0,1,223.93,290.9Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.33,290.9a12,12,0,0,1,2,1.63,11.53,11.53,0,0,1,1.63,2,13.07,13.07,0,0,1-3.6-3.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.68,292.71a13.13,13.13,0,0,1-5.1,0,11,11,0,0,1,2.55-.25A11.61,11.61,0,0,1,224.68,292.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.13,290.16a13.08,13.08,0,0,1,0,5.09,13.08,13.08,0,0,1,0-5.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72,290.9a12,12,0,0,1-1.63,2,11.61,11.61,0,0,1-2,1.63,12,12,0,0,1,1.63-2A12.54,12.54,0,0,1,232.72,290.9Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.11,290.9a12.54,12.54,0,0,1,2,1.63,12,12,0,0,1,1.63,2,12,12,0,0,1-2-1.63A12.54,12.54,0,0,1,229.11,290.9Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.46,292.71a13.08,13.08,0,0,1-5.09,0,11,11,0,0,1,2.55-.25A11.58,11.58,0,0,1,233.46,292.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92,290.16a13.08,13.08,0,0,1,0,5.09,11,11,0,0,1-.25-2.54A11.61,11.61,0,0,1,230.92,290.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,290.9a13.07,13.07,0,0,1-3.6,3.61,11.53,11.53,0,0,1,1.63-2A12.46,12.46,0,0,1,241.5,290.9Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9,290.9a12.54,12.54,0,0,1,2,1.63,12,12,0,0,1,1.62,2,13.44,13.44,0,0,1-3.6-3.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,292.71a12.25,12.25,0,0,1-2.55.25,12.09,12.09,0,0,1-2.54-.25,10.89,10.89,0,0,1,2.54-.25A11.61,11.61,0,0,1,242.25,292.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,290.16a13.08,13.08,0,0,1,0,5.09,13.08,13.08,0,0,1,0-5.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.51,291.06v1.85H204v-1.85a1.19,1.19,0,1,0-2.37,0v1.85h-.53v-1.85a1.71,1.71,0,1,1,3.42,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43,292.23v3.94h4.75v-3.94Zm2.77,2.89h-.84l.2-.95a.41.41,0,0,1-.2-.36.42.42,0,1,1,.84,0,.41.41,0,0,1-.2.36Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.18,251.22v-6.88a.65.65,0,0,1,1.3,0v6.23h3.16a.65.65,0,0,1,0,1.3h-3.81A.64.64,0,0,1,230.18,251.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.74,244.71a4.29,4.29,0,0,1,0,5.91,3.83,3.83,0,0,1-2.79,1.25,3.93,3.93,0,0,1-2.86-1.25,4.34,4.34,0,0,1,0-5.91,3.9,3.9,0,0,1,2.86-1.25A3.79,3.79,0,0,1,242.74,244.71Zm-.15,2.95a3,3,0,0,0-.8-2,2.49,2.49,0,0,0-1.84-.83,2.52,2.52,0,0,0-1.89.83,3,3,0,0,0,0,4.08,2.49,2.49,0,0,0,3.73,0A3,3,0,0,0,242.59,247.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,247.68a4.26,4.26,0,0,1,4.31-4.22,4.32,4.32,0,0,1,2.66.91.66.66,0,1,1-.81,1,3.1,3.1,0,0,0-1.85-.63,2.91,2.91,0,0,0-2.1.85,2.8,2.8,0,0,0-.88,2,2.75,2.75,0,0,0,.88,2,2.88,2.88,0,0,0,2.1.86,3.23,3.23,0,0,0,1.6-.45v-1.6H250.1a.67.67,0,0,1-.66-.66.65.65,0,0,1,.66-.66h2.32a.66.66,0,0,1,.68.66v2.58a1.2,1.2,0,0,1,0,.2.13.13,0,0,0,0,0v0a.56.56,0,0,1-.22.28,4.31,4.31,0,0,1-2.65.91A4.25,4.25,0,0,1,245.86,247.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,244.34a.63.63,0,0,1,.64-.65.65.65,0,0,1,.65.65v6.88a.65.65,0,0,1-.65.65.63.63,0,0,1-.64-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.58,251.22a.64.64,0,1,1-1.27,0v-6.78h0a.63.63,0,0,1,1.14-.4l3.78,5.22v-4.81a.63.63,0,0,1,.63-.63.64.64,0,0,1,.64.63v6.78a.65.65,0,0,1-.64.65.63.63,0,0,1-.48-.24.13.13,0,0,1-.06-.07l-3.74-5.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.59,
    y: 309.66,
    width: 34.88,
    height: 10.85,
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.11,316.7v-3.44a.32.32,0,0,1,.32-.33.33.33,0,0,1,.33.33v3.12h1.58a.32.32,0,0,1,.32.32.33.33,0,0,1-.32.33h-1.91A.32.32,0,0,1,239.11,316.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39,313.44a2.15,2.15,0,0,1,0,3,1.93,1.93,0,0,1-1.4.63,2,2,0,0,1-1.43-.63,2.18,2.18,0,0,1,0-3,2,2,0,0,1,1.43-.62A1.92,1.92,0,0,1,245.39,313.44Zm-.08,1.48a1.51,1.51,0,0,0-.4-1,1.26,1.26,0,0,0-.92-.42,1.31,1.31,0,0,0-1,.42,1.5,1.5,0,0,0-.39,1,1.48,1.48,0,0,0,.39,1,1.31,1.31,0,0,0,1,.42,1.26,1.26,0,0,0,.92-.42A1.49,1.49,0,0,0,245.31,314.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,314.93a2.13,2.13,0,0,1,2.15-2.11,2.23,2.23,0,0,1,1.34.45.35.35,0,0,1,.06.48.33.33,0,0,1-.47.05,1.56,1.56,0,0,0-.93-.32,1.44,1.44,0,0,0-1,.43,1.38,1.38,0,0,0,0,2,1.44,1.44,0,0,0,1,.43,1.62,1.62,0,0,0,.8-.22v-.8h-.83a.35.35,0,0,1-.34-.34.33.33,0,0,1,.34-.32h1.16a.33.33,0,0,1,.34.32v1.3a.36.36,0,0,1,0,.1s0,0,0,0h0a.29.29,0,0,1-.11.14,2.15,2.15,0,0,1-3.48-1.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,313.26a.32.32,0,0,1,.32-.33.33.33,0,0,1,.33.33v3.44a.33.33,0,0,1-.33.33.32.32,0,0,1-.32-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,316.7a.33.33,0,0,1-.32.33.32.32,0,0,1-.32-.33v-3.39h0a.31.31,0,0,1,.13-.27.32.32,0,0,1,.44.07l1.89,2.62v-2.41a.32.32,0,0,1,.32-.32.33.33,0,0,1,.32.32v3.39a.33.33,0,0,1-.32.33.31.31,0,0,1-.24-.12s0,0,0,0l-1.87-2.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 248.03,
    cy: 185.34,
    r: 42.5,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,220c-.88.63-1.78,1.22-2.7,1.79a42.57,42.57,0,0,1-7,3.37c-.57.22-1.15.42-1.73.62-1.31.43-2.66.8-4,1.1h0c-1.2.26-2.42.48-3.66.64-1.63-2.43-3-4.54-3.89-6.17-.62-1.08-1.44-2.59-2.27-4.29-2.57-5.21-5.28-12.22-2.77-14.13l.14-.1.2-.11.13-.06a2.3,2.3,0,0,1,.73-.19,4.12,4.12,0,0,1,1.06,0,15.47,15.47,0,0,1,5.19,1.82h0c.47.23.95.49,1.47.78l.2.11C258.05,207.56,265.36,213.64,272.69,220Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.19,218.83c-.49.39-1,.76-1.5,1.12-.88.63-1.78,1.22-2.7,1.79a42.57,42.57,0,0,1-7,3.37c-.57.22-1.15.42-1.73.62-1.31.43-2.66.8-4,1.1h0c-1.2.26-2.42.48-3.66.64l-.74.09c-2.61-4.1-4.81-7.8-6.34-10.69h0l-.26-.49q-.81-1.57-1.41-3-.45-1-.78-2-.21-.63-.39-1.23c-.1-.35-.18-.68-.26-1s-.13-.65-.18-1a8.8,8.8,0,0,1-.12-2.24,4.9,4.9,0,0,1,.35-1.58,3.45,3.45,0,0,1,.35-.66l.21-.28a3.07,3.07,0,0,1,.25-.26,2,2,0,0,1,.27-.22l.12-.08.14-.1.2-.11.13-.06,0,0a4,4,0,0,1,.64-.23A9.26,9.26,0,0,1,251,203a0,0,0,0,0,0,0,23.14,23.14,0,0,1,2.77,1.15h0a42.55,42.55,0,0,1,5.08,3C263.38,210.12,268.85,214.43,274.19,218.83Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.54,209.78c-.24-.23-.48-.45-.74-.67h0l-.27-.22-.2-.15a2.54,2.54,0,0,0-.34-.23l-.34-.22h0l-.2-.11-.13-.06s0,0,0,0l-.42-.19a6.5,6.5,0,0,0,.34.7,10.16,10.16,0,0,0,1.52,2l.67.61.55.43,0,0a0,0,0,0,0,0,0,6.84,6.84,0,0,0,1.4.79A8.6,8.6,0,0,0,255.54,209.78Zm0,0c-.24-.23-.48-.45-.74-.67h0l-.27-.22-.2-.15a2.54,2.54,0,0,0-.34-.23l-.34-.22h0l-.2-.11-.13-.06s0,0,0,0l-.42-.19a6.5,6.5,0,0,0,.34.7,10.16,10.16,0,0,0,1.52,2l.67.61.55.43,0,0a0,0,0,0,0,0,0,6.84,6.84,0,0,0,1.4.79A8.6,8.6,0,0,0,255.54,209.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,221.74a42.57,42.57,0,0,1-7,3.37c-.57.22-1.15.42-1.73.62-1.31.43-2.66.8-4,1.1h0c-1.2.26-2.42.48-3.66.64l-.74.09c-2.61-4.1-4.81-7.8-6.34-10.69h0l-.26-.49q-.81-1.57-1.41-3-.45-1-.78-2-.21-.63-.39-1.23c-.1-.35-.18-.68-.26-1s-.13-.65-.18-1a9.83,9.83,0,0,1-.12-2.24,4.9,4.9,0,0,1,.35-1.58,3.45,3.45,0,0,1,.35-.66l.21-.28a3.07,3.07,0,0,1,.25-.26,2,2,0,0,1,.27-.22l.12-.08.14-.1.2-.11.13-.06,0,0a4.13,4.13,0,0,1,.65-.22,4.74,4.74,0,0,1,.89-.14l.22.18,3.54,3h0l2.87,2.4,1.37,1.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3,225.73c-1.31.43-2.66.8-4,1.1h0c-1.2.26-2.42.48-3.66.64l-.74.09a42.78,42.78,0,0,1-18.55-2l-.11,0-.1,0-.48-.17A42.62,42.62,0,0,1,222,218.91c1.19-2.09,2.29-3.93,3.32-5.54.74-1.16,1.43-2.2,2.09-3.13,0,0,0,0,0,0h0c3.49-5,5.9-7,7.78-8l.35-.17a3,3,0,0,1,.41-.19c.25-.11.49-.19.72-.27a20.83,20.83,0,0,1,7.93-.77A12,12,0,0,1,251,203a0,0,0,0,0,0,0,5.32,5.32,0,0,1,1.14,1.28h0q.52.83,1,1.71l.36.64c.42.76.83,1.54,1.23,2.36a.51.51,0,0,1,.07.15h0c.2.41.4.82.6,1.25s.4.84.59,1.28a0,0,0,0,0,0,0,132.76,132.76,0,0,1,5.19,13.74C261.23,225.5,261.26,225.61,261.3,225.73Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.79,224a8.56,8.56,0,0,0-3.19.56,8.37,8.37,0,0,0,3.19.56,8.54,8.54,0,0,0,3.2-.56A8.54,8.54,0,0,0,246.79,224Zm-18.16-14.56c-.15.07-.29.16-.43.24a3.62,3.62,0,0,0-.41.27.83.83,0,0,0-.18.13l-.21.15h0s0,0,0,0l0,0c-.32.25-.61.52-.9.79a8.8,8.8,0,0,0-1.87,2.66,6,6,0,0,0,.72-.35,9.61,9.61,0,0,0,1.94-1.51,8.48,8.48,0,0,0,1.86-2.66Zm26.77.94c-.2-.42-.4-.84-.61-1.25l-.27-.22-.2-.15a2.54,2.54,0,0,0-.34-.23l-.34-.22h0l-.2-.11-.13-.07-.42-.19a6.5,6.5,0,0,0,.34.7,10.16,10.16,0,0,0,1.52,2l.67.61.55.43,0,0C255.8,211.2,255.6,210.78,255.4,210.36Zm0,0c-.2-.42-.4-.84-.61-1.25l-.27-.22-.2-.15a2.54,2.54,0,0,0-.34-.23l-.34-.22h0l-.2-.11-.13-.07-.42-.19a6.5,6.5,0,0,0,.34.7,10.16,10.16,0,0,0,1.52,2l.67.61.55.43,0,0C255.8,211.2,255.6,210.78,255.4,210.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.21,209.27a49.05,49.05,0,0,1-2.06,8.68c-.86,2.68-1.71,5.13-2.54,7.38A42.62,42.62,0,0,1,222,218.91c-.84-.65-1.66-1.34-2.44-2,1.42-1.89,2.85-3.72,4.27-5.47,4.72-5.81,8.76-9,11.38-9.19l.3,0C237.71,202.18,238.79,204.48,238.21,209.27Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.77,210.11a42.62,42.62,0,0,1-1,5.36,67.07,67.07,0,0,1-2.56,7.47h0l-1.06,2.59-.1,0-.48-.17A42.62,42.62,0,0,1,222,218.91c-.84-.65-1.66-1.34-2.44-2l-.81-.75a72.74,72.74,0,0,1,8.6-9.43c3.86-3.4,6.49-4.76,8.26-4.84h.36C239,202,239.18,206.36,238.77,210.11Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63,209.42c-.15.07-.29.16-.43.24a3.62,3.62,0,0,0-.41.27.83.83,0,0,0-.18.13l-.23.18,0,0c-.32.25-.61.52-.9.79a8.8,8.8,0,0,0-1.87,2.66,6,6,0,0,0,.72-.35,9.61,9.61,0,0,0,1.94-1.51,8.48,8.48,0,0,0,1.86-2.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,222.94h0v0c-.31.87-.63,1.74-.95,2.6l-.11,0-.1,0c.37-.85.74-1.7,1.09-2.56A0,0,0,0,1,235.25,222.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.76,217c-4.51.16-10.61-7.88-12.48-13.79-.12-.41,1.2-4.15,2.59-8.78.83-2.81,1.69-6,2.27-8.9.12-.6,17.51,8.1,17.51,8.1a47.57,47.57,0,0,0-4,10.9,6.69,6.69,0,0,0-.11,1.23c0,.06,0,.13,0,.2C253.45,208.35,252.12,216.86,247.76,217Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.26,185.86c-.13,5.13.59,17.71,10.36,19.87a10.52,10.52,0,0,0,1.9.26,1.68,1.68,0,0,0,0-.2,7.55,7.55,0,0,1,.1-1.23,47.54,47.54,0,0,1,4-10.91S245.1,187.38,241.26,185.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,166.28c-1.88,6.68,2,25.8,6.85,30,7,6.06,18.2,6.41,23.3-1.93,4.94-8.09-.6-32.92-6-36.69C253.3,152.07,239.8,156.4,237,166.28Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,178.35s-.09.09-.07.14c.34,1.27.52,2.78-.53,3.48,0,0,0,.09,0,.07C254.54,181.5,254.28,179.5,253.75,178.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29,177.29c-2.1.34-1.27,4.5.67,4.19S254,177,252.29,177.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.14,176.87c0-.05.11,0,.12.09.22,1.3.68,2.75,1.93,2.95,0,0,.05.07,0,.07C261.73,180.06,261.13,178.13,261.14,176.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,175.29c2-.56,3,3.56,1.14,4.09S260.31,175.77,262,175.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,175.25c.54-.26,1-.58,1.51-.88s1.06-.56,1.36-1.19a.89.89,0,0,0-.35-1,2.19,2.19,0,0,0-2.24.2,3.3,3.3,0,0,0-1.59,1.74A1,1,0,0,0,250.33,175.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.56,173.6a16.91,16.91,0,0,1-1.74,0,2.9,2.9,0,0,1-1.79-.31.9.9,0,0,1-.24-1.07,2.22,2.22,0,0,1,2-1,3.29,3.29,0,0,1,2.26.67A1,1,0,0,1,263.56,173.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.54,189.65c.27.35.51.82,1,.93a3.36,3.36,0,0,0,1.44-.11,0,0,0,0,1,.05.08,1.81,1.81,0,0,1-1.76.45,1.41,1.41,0,0,1-.84-1.31C254.4,189.61,254.5,189.6,254.54,189.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.65,185.88a4.43,4.43,0,0,0,3.32,1.37,5.78,5.78,0,0,0,1.59-.24,1.4,1.4,0,0,0,.29-.09l.28-.1a.33.33,0,0,0,.2-.34h0a.5.5,0,0,0,0-.13h0l0-.11c-.17-1-.56-2.49-.56-2.49.39.11,2.41.57,2.28.06a67.52,67.52,0,0,0-4.34-12.95.12.12,0,0,0-.23.08c.9,4.12,2.52,8.05,3.5,12.18a7.89,7.89,0,0,0-2.2-.22c-.13.07.82,2.87.86,3.32v.05a6.21,6.21,0,0,1-4.82-.51C255.64,185.69,255.55,185.79,255.65,185.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.26,181.24c5.07.25,7.59-5.85,6.3-10.69,0,0,13.51,1.51,13.93-9.32a10.63,10.63,0,0,0,8.86,4.67l1.59,3.95c1.37-.43,2.76-4.39-.69-7.4,0,0-.34-5.38-4.39-8.53a7.33,7.33,0,0,0-7.94-.94,11.14,11.14,0,0,0-8.17-1.84,9.54,9.54,0,0,0-6.9,5.31s-6.64,1.42-7.68,6.19a9.82,9.82,0,0,0,1.48,7.89s-1.63,1.89-.7,5.92C232.55,179,234.73,181.16,236.26,181.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,160.27a12.3,12.3,0,0,1,.08,2.64,10.55,10.55,0,0,1-.43,2.57,6.83,6.83,0,0,1-3,4,11.11,11.11,0,0,1-4.94,1.35c-.87,0-1.75,0-2.63,0s-1.76-.16-2.65-.22c.86.2,1.74.35,2.62.52s1.78.12,2.68.19a10.85,10.85,0,0,0,5.24-1.3,7.11,7.11,0,0,0,3.18-4.35A10.72,10.72,0,0,0,256.17,160.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,166.38a14.16,14.16,0,0,1-4.13-2.12,8.19,8.19,0,0,1-1.61-1.61,10.29,10.29,0,0,1-1.18-2,5.94,5.94,0,0,0,.78,2.29,6.23,6.23,0,0,0,1.63,1.84,7.86,7.86,0,0,0,2.15,1.16A7.38,7.38,0,0,0,263.24,166.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,181.83s-4.6-6-7.35-4.36.88,10.52,4.24,11.61a3.36,3.36,0,0,0,4.43-2Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,180a0,0,0,0,0,0,.09c2.36.84,3.67,2.94,4.61,5.13a1.85,1.85,0,0,0-2.79-.39.07.07,0,0,0,.06.12,2.09,2.09,0,0,1,2.31.63,10.24,10.24,0,0,1,1.16,1.8c.12.2.49.07.4-.16l0-.06C240.86,184.19,238.39,180.15,235.21,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.53,183.62a.32.32,0,0,1-.32.3.33.33,0,0,1-.3-.32.31.31,0,1,1,.62,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254,183.6a.31.31,0,0,1-.61,0,.3.3,0,0,1,.32-.29A.31.31,0,0,1,254,183.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.6,185.75a.32.32,0,0,1-.32.3.3.3,0,0,1-.29-.32.31.31,0,0,1,.32-.3A.3.3,0,0,1,251.6,185.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.81,181.1a.31.31,0,0,1-.32.29.3.3,0,0,1-.29-.32.31.31,0,1,1,.61,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.76,183a.31.31,0,0,1-.32.3.3.3,0,0,1-.29-.32.32.32,0,0,1,.32-.3A.3.3,0,0,1,250.76,183Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.74,179.2a.3.3,0,0,1-.32.29.31.31,0,0,1-.29-.32.31.31,0,0,1,.61,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.28,180.84a.3.3,0,0,1-.32.29.32.32,0,0,1-.3-.32.3.3,0,0,1,.32-.29A.32.32,0,0,1,264.28,180.84Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.8,182.89a.31.31,0,0,1-.32.29.3.3,0,0,1-.29-.32.31.31,0,0,1,.61,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267,181.57a.3.3,0,0,1-.32.29.31.31,0,1,1,0-.61A.32.32,0,0,1,267,181.57Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.55,452.19c2.79,1,85.33,2.64,88.43.74.37-.19,1.71-27.5,1.71-27.5-.1-.39,1.28-3,3.39-6.67,5.88-10.27,17.39-28.67,17.39-28.67l-49-14.81-20.12,40.31-5.13,10.28s-11.25,4.4-21.07,8.79c0,0,0,0,0,0-6,2.69-11.31,5.15-12.54,6.07C193.45,443.19,190.77,451.21,193.55,452.19Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.55,452.19c2.79,1,85.33,2.64,88.43.74.37-.19,1.71-27.5,1.71-27.5-.1-.39,1.28-3,3.39-6.67l-51.72-3.17-5.13,10.28s-11.25,4.4-21.07,8.79c0,0,0,0,0,0-6,2.69-11.31,5.15-12.54,6.07C193.45,443.19,190.77,451.21,193.55,452.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,452.5c2.87,1,85.51,2.43,88.7.49,1.21-.73,2.67-13.45,1.78-27.56l-53.28-.85s-30.86,13.64-34.13,16.14S190.34,451.48,193.21,452.5Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,453c-1.17.7-12.91,1-27.5,1l28-28.55h0l1.3,0C284.58,439.54,283.12,452.27,281.91,453Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,449.21c13.86-.1,69.77.79,83.48,1.75.11,0,.11.08,0,.08-13.74.4-69.64-.94-83.49-1.6C194.15,449.43,194.16,449.21,194.45,449.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,437.84a11.11,11.11,0,0,1,8.23,3.53,10.73,10.73,0,0,1,3,7.45c0,.08-.16.08-.17,0a12.88,12.88,0,0,0-11-10.8A.09.09,0,0,1,201.65,437.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,425.9c5.54,0,11.94,2.08,15.31,6.68.13.17-.13.36-.29.27a76.39,76.39,0,0,0-15.13-6.27A.35.35,0,0,1,226,425.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.73,427.49c5.54,0,11.94,2.09,15.31,6.68.13.18-.13.36-.29.27a77.6,77.6,0,0,0-15.13-6.27A.35.35,0,0,1,221.73,427.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.42,429.09c5.54,0,11.94,2.08,15.31,6.68.13.18-.13.36-.29.27a76.39,76.39,0,0,0-15.13-6.27A.35.35,0,0,1,217.42,429.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,430.68c5.54,0,11.94,2.09,15.31,6.68.13.18-.13.36-.29.28A77,77,0,0,0,213,431.36.35.35,0,0,1,213.11,430.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.62,437.74c6.22.12,6,9.79-.19,9.66S268.39,437.61,274.62,437.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.6,419.13c2.93,3.92,7.44,6.42,11.35,9.22a.67.67,0,0,0,1-.43.15.15,0,0,0,.18-.15,29.08,29.08,0,0,0-4.8-14.27c-1.69-2.45-5.19-4.78-8-2.5S218.89,416.85,220.6,419.13Zm-.18-4.59c.66-6,6-1.3,7.19.55a31.52,31.52,0,0,1,2,3.78,86.69,86.69,0,0,1,3,8.27c-1.83-1.5-3.78-2.82-5.66-4.24C224.65,421.2,220.06,417.86,220.42,414.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.88,424.57c-.37-3.63-4.49-4.48-7.42-4a29.06,29.06,0,0,0-13.53,6.59.14.14,0,0,0,0,.23.68.68,0,0,0,.4,1c4.73.82,9.69,2.28,14.53,1.62C249.69,429.67,253.23,428,252.88,424.57Zm-13.11,3.64c-2.34-.34-4.65-.8-7-1.06,2.65-1.28,5.22-2.66,8-3.68a31.89,31.89,0,0,1,4.07-1.25c2.14-.46,9.27,0,5.44,4.74C248.16,429.55,242.55,428.62,239.77,428.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,418.22l-58.11-8.8s27.93-55.68,45.22-85.89c9.62-16.8,35.92-17.62,48.71,2.5,17.09,26.89,30.35,52.09,37.95,66.05l13.19,1.13-2.85,21.54-43.81,9.81c-16.78,2-28.56-27.87-28.83-27.36C300.14,401.12,290.8,418.22,290.8,418.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,397.33c1.65-3.38,2.94-7,4.41-10.44s2.85-6.71,4.26-10.07c2.85-6.79,5.8-13.55,8.57-20.37,1.55-3.83,3-7.71,4.43-11.58a.08.08,0,0,1,.15.05c-1.13,3.65-2.29,7.3-3.52,10.92.33-.62.65-1.25,1-1.86.93-1.67,1.9-3.32,2.86-5a.06.06,0,1,1,.1.06c-.89,1.65-1.78,3.3-2.71,4.94-.46.81-1,1.62-1.45,2.43A255.07,255.07,0,0,1,308,386.23c-1.85,3.79-4,7.42-5.86,11.21C302.08,397.56,301.9,397.45,302,397.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5,407.89c2.8-4.32,9.48-17.41,11.87-21.93,4.83-9.15,9.25-18.49,13.44-27.95,2.36-5.35,4.57-10.75,6.76-16.17,0,0,.07,0,.06,0a305,305,0,0,1-11.47,28.71c-4.26,9.39-18,34.69-20.48,37.43C289.59,408.1,289.43,408,289.5,407.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.58,349.07c5,8.94,10.12,17.82,15.15,26.75q3.81,6.78,7.6,13.56c1.18,2.13,2.33,4.28,3.56,6.39a12,12,0,0,0,4.59,4.76,35.81,35.81,0,0,0,7.29,2.55c2.82.82,5.63,1.71,8.47,2.49a.1.1,0,0,1-.06.2c-2.53-.68-5.09-1.26-7.63-1.89a68.71,68.71,0,0,1-6.93-1.86,11.25,11.25,0,0,1-5.13-3.55,42.37,42.37,0,0,1-3.6-6q-7.53-13.79-14.93-27.63c-2.81-5.25-5.59-10.51-8.43-15.74C325.52,349.07,325.56,349,325.58,349.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.12,410.07c-3.48-.64-7.05-.94-10.56-1.39L271,407.31c-7-.91-30.93-4.72-32.73-5.32a.12.12,0,0,1,0-.23c1.71-.05,17.36,2,20.88,2.55,7,1,14,2.28,21,3.46,2,.34,4,.72,6,1.07s4,.78,6,1A.1.1,0,0,1,292.12,410.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.34,464.63c1-2.77,53.68-66.37,57.14-67.49.39-.15,21.95,16.65,21.95,16.65C335.3,415.05,378,408,378,408l-1.8,51-77-5s-10.67,5.67-20.4,10.24h0c-6,2.84-11.28,5.21-12.78,5.53C262.09,470.59,254.27,467.38,255.34,464.63Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,469.77c1.5-.31,6.79-2.69,12.78-5.53h0c9.73-4.57,20.4-10.24,20.4-10.24l17.13,1.11L345.06,413c-5.93.79-10.35,1.22-10.63.82,0,0-21.55-16.8-21.95-16.65-3.46,1.12-56.08,64.71-57.14,67.48S262.09,470.6,266,469.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.88,464.69c1.11-2.83,54-66.38,57.51-67.53,1.34-.45,11.93,6.75,22,16.63l-34.12,40.93s-30.47,14.48-34.5,15.33S253.78,467.53,254.88,464.69Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18,465.9c9.12-10.44,44.93-53.39,53.15-64.4.07-.09,0-.14-.06-.05-9.27,10.14-44.73,53.38-53.26,64.3C257.83,466,258,466.12,258.18,465.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,467.86a11.15,11.15,0,0,0,2.7-8.54,10.84,10.84,0,0,0-3.71-7.11c-.07,0-.16.07-.11.13a12.85,12.85,0,0,1,1,15.41A.09.09,0,0,0,271.5,467.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.46,457.17c3.61-4.21,6.21-10.41,4.93-16-.05-.21-.35-.14-.39,0a76.87,76.87,0,0,1-5.12,15.56A.34.34,0,0,0,296.46,457.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.44,459.4c3.61-4.22,6.21-10.41,4.93-16-.05-.22-.36-.14-.4,0A75.84,75.84,0,0,1,291.85,459,.35.35,0,0,0,292.44,459.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,461.62c3.6-4.21,6.21-10.41,4.93-16-.05-.21-.36-.14-.4,0a76.25,76.25,0,0,1-5.12,15.56A.35.35,0,0,0,288.42,461.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.4,463.85c3.6-4.22,6.21-10.41,4.93-16-.05-.22-.36-.14-.4,0a76.36,76.36,0,0,1-5.12,15.55A.35.35,0,0,0,284.4,463.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.19,412.63c4-4.79-3.48-11-7.45-6.16S315.22,417.43,319.19,412.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,471.24c3.58-.66,4.09-4.84,3.34-7.72a29.07,29.07,0,0,0-7.68-12.94.15.15,0,0,0-.23,0,.68.68,0,0,0-1,.48c-.43,4.79-1.48,9.85-.42,14.62C298.66,468.49,300.62,471.88,304,471.24Zm-4.71-12.76c.15-2.36.41-4.7.48-7.06,1.49,2.53,3.08,5,4.32,7.66a31.28,31.28,0,0,1,1.58,3.95c.64,2.1.72,9.25-4.27,5.81C298.66,467,299.11,461.29,299.3,458.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9,438.67c-3.66,3.24-5.78,7.95-8.25,12.07a.68.68,0,0,0,.51,1,.15.15,0,0,0,.17.16,29,29,0,0,0,13.82-6c2.3-1.88,4.34-5.56,1.83-8.21C312.61,435.2,309,436.78,306.9,438.67Zm4.57-.55c6.06.16,1.79,5.89,0,7.21a33,33,0,0,1-3.6,2.27c-2.58,1.44-5.31,2.48-8,3.65,1.34-1.95,2.49-4,3.76-6C305.17,442.88,308.13,438,311.47,438.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,395.07s66-8.86,87.61-3.05c30.13,8.12,33.58,44.31,10.38,58.09-29.4,17.45-131.38,7.72-131.38,7.72l28.46-48s42.73-8,81-4.87L352,414.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,413.08a2,2,0,0,0,.07-.26c0-.07,0-.14.05-.21l.15-.49a8.33,8.33,0,0,1,.36-1c.13-.33.28-.65.43-1a7.34,7.34,0,0,1,.55-.89s.05,0,.08,0l.05,0,.07,0a.15.15,0,0,1,.07,0c4.69-.75,36.51-4.36,41.24-4.74s9.54-.67,14.31-.9a254.48,254.48,0,0,1,28.57.11c.89.05,1.78.13,2.67.2.19-.06.4-.09.59-.13.47-.1.92-.21,1.39-.28.87-.15,1.74-.25,2.61-.36,1.81-.22,3.63-.35,5.43-.64.11,0,.15.16,0,.18-1.82.36-3.62.86-5.44,1.22l-1.58.29c3.48.35,6.95.8,10.42,1.3.11,0,.11.2,0,.19-4.72-.51-9.49-.76-14.24-.88s-9.43-.2-14.15-.11c-9.54.19-19.09.71-28.62,1.39-5.34.38-37.8,4.16-43.15,4.17h-.06a3.42,3.42,0,0,1-.17.4c-.16.31-.32.62-.49.92s-.33.59-.52.87-.18.28-.28.41l-.14.21a1.07,1.07,0,0,0-.15.22C346.38,413.29,346.2,413.2,346.27,413.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,454.84c1.68-2.76,3.14-5.72,4.7-8.57l4.68-8.58C346.9,432,358,412.83,359.11,411.5c.07-.08.19,0,.16.12-.55,1.5-7.54,14.2-9.14,17-3.21,5.66-6.56,11.19-9.87,16.78-.94,1.59-1.92,3.16-2.87,4.75s-2,3.13-2.86,4.76C334.48,455,334.34,454.94,334.4,454.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,416.76c2.84-.62,5.74-1,8.6-1.44s5.73-.94,8.6-1.39q8.61-1.38,17.24-2.6c11.48-1.61,23-2.87,34.52-3.58,6.52-.4,13-.57,19.56-.81.14,0,.13.23,0,.24-11.6.06-23.23,1.29-34.77,2.6s-22.84,2.78-34.23,4.39l-9.65,1.39c-3.27.48-6.54,1.1-9.82,1.41C360.76,417,360.71,416.79,360.84,416.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,334.15c-6.32,11-31.49,45.05-39.41,46.18-8.24,1.18-38.62-1.42-44.16-7.95-2.71-3.19,1.67-30.58,5.88-29.05s30.2,7.81,33.54,7.32,30.27-26.57,40.2-32.19C374,308.76,364.24,328.21,360.83,334.15Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.82,344.2l-6.41,33.94s30.43,6.23,39.4,3.61,34.05-38.28,41.37-52.38.92-17.81-12.21-9-34.17,28.48-36.22,28.57S289.82,344.2,289.82,344.2Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.16,323a8.53,8.53,0,0,0-1.8,2.58,8.36,8.36,0,0,0,2.58-1.8,8.56,8.56,0,0,0,1.81-2.58A8.58,8.58,0,0,0,355.16,323Zm-65.65,51.72a8.41,8.41,0,0,0-3.1.54,8.22,8.22,0,0,0,3.1.55,8.38,8.38,0,0,0,3.11-.55A8.57,8.57,0,0,0,289.51,374.68Zm49.73-10.14a8.5,8.5,0,0,0-3.11.54,8.31,8.31,0,0,0,3.11.55h.41c.25-.33.53-.67.79-1C340,364.57,339.64,364.55,339.24,364.54Zm-21.66,8.13a9.17,9.17,0,0,0,0,6.2,8.46,8.46,0,0,0,.55-3.1A8.26,8.26,0,0,0,317.58,372.67Zm25.49-33.17a8.21,8.21,0,0,0-.54,3.1,8.45,8.45,0,0,0,.54,3.1,8.26,8.26,0,0,0,.55-3.1A8,8,0,0,0,343.07,339.5ZM355.16,323a8.53,8.53,0,0,0-1.8,2.58,8.36,8.36,0,0,0,2.58-1.8,8.56,8.56,0,0,0,1.81-2.58A8.58,8.58,0,0,0,355.16,323Zm-32.73,28a8.16,8.16,0,0,0-1.81,2.58,8.3,8.3,0,0,0,2.58-1.82,8.16,8.16,0,0,0,1.81-2.58A8.46,8.46,0,0,0,322.43,350.93Zm-30.72-6.35h0l-.28.26a8.13,8.13,0,0,0-1.8,2.58,8.37,8.37,0,0,0,2.58-1.82c.24-.25.48-.51.7-.78ZM304,361.38a8.29,8.29,0,0,0-2.58-1.8,8.39,8.39,0,0,0,1.81,2.58,8.56,8.56,0,0,0,2.58,1.81A8.48,8.48,0,0,0,304,361.38Zm35.28,3.16a8.5,8.5,0,0,0-3.11.54,8.31,8.31,0,0,0,3.11.55h.41c.25-.33.53-.67.79-1C340,364.57,339.64,364.55,339.24,364.54Zm3.83-25a8.21,8.21,0,0,0-.54,3.1,8.45,8.45,0,0,0,.54,3.1,8.26,8.26,0,0,0,.55-3.1A8,8,0,0,0,343.07,339.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.32,362.71c.52-2.69,2.51-13.45,2.8-16.16,0,0-.06-.06-.08,0-.78,2.53-3.06,13.09-3.58,15.78a150.44,150.44,0,0,0-2.65,16.19c0,.09.14.15.17,0C293.45,373.35,294.3,368,295.32,362.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.18,329.36c-7.32,14.11-32.38,49.76-41.37,52.38-6.8,2-25.88-1.1-34.75-2.72l75.68-63.38C368,316,368.67,320.69,364.18,329.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.65,396.65,412.48,401c-.1-1.52-11.8-44.44-20.22-60.78-10.79-20.95-15.58-24.15-18.78-25.22-4.1-1.37-12.51-1.36-15,2.6C345.12,339,336.63,395.7,337.65,396.65Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.89,322.31c-.4.8-.79,1.61-1.17,2.47a13.4,13.4,0,0,0,1.22-1,8.56,8.56,0,0,0,1.81-2.58A7,7,0,0,0,355.89,322.31Zm22.52,69.32a8.41,8.41,0,0,0-1.8,2.58,8.24,8.24,0,0,0,2.58-1.8,8.69,8.69,0,0,0,1.81-2.58A8.58,8.58,0,0,0,378.41,391.63Zm-22.52-69.32c-.4.8-.79,1.61-1.17,2.47a13.4,13.4,0,0,0,1.22-1,8.56,8.56,0,0,0,1.81-2.58A7,7,0,0,0,355.89,322.31Zm43.95,36.55h0a5.18,5.18,0,0,0-.58-.28,7.06,7.06,0,0,0,1.12,1.81C400.2,359.88,400,359.36,399.84,358.86Zm-16.45-34.65a11.81,11.81,0,0,0-.91-.82h0a7.27,7.27,0,0,0-1.65-1,8.27,8.27,0,0,0,1.81,2.58,9.25,9.25,0,0,0,1.87,1.45,4.72,4.72,0,0,0,.71.36A8.3,8.3,0,0,0,383.39,324.21Zm-20.27,35a8.32,8.32,0,0,0-2.58-1.81,9.09,9.09,0,0,0,4.4,4.39A8.59,8.59,0,0,0,363.12,359.19Zm18.78,10.36a8.26,8.26,0,0,0-3.1.55,9.2,9.2,0,0,0,6.21,0A8.27,8.27,0,0,0,381.9,369.55Zm-18.25-32.81a8.22,8.22,0,0,0-3.1.55,8.62,8.62,0,0,0,3.1.54,8.28,8.28,0,0,0,3.1-.54A8.29,8.29,0,0,0,363.65,336.74Zm-8.1,44.69a8.22,8.22,0,0,0-.55,3.1,8.5,8.5,0,0,0,.55,3.1,9.17,9.17,0,0,0,0-6.2Zm42.81-3.11a9,9,0,0,0,0,6.21,9.2,9.2,0,0,0,0-6.21ZM383,344.86a9,9,0,0,0,0,6.2,8.7,8.7,0,0,0,.54-3.1A8.41,8.41,0,0,0,383,344.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,324.53c18.91,23.24,39.57,61.85,29.45,69.32-9.24,6.82-41.18-1.84-61.08-10.87-3.78-1.71,13.72-35.09,17.56-32.84a112.15,112.15,0,0,0,12.55,6.47c1.09.36-4.62-7.42-10.46-25.72C368,312.3,375.16,311.24,386,324.53Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.65,345c-.23,4,9.62,3.71,9.62,3.71a7.36,7.36,0,0,0-3.2,3.84c-.9,2.89,3.24,5.57,3.24,5.57a9,9,0,0,0-2.73,4.58c-.58,2.86,3.22,6.15,3.22,6.15a8,8,0,0,0,.14,5.54c2.09,4.66,9.92,5.17,14.71,6.44a104.3,104.3,0,0,1,15.61,5.9l10.9-35.24s-20.34-13.58-26.22-13.62C343,337.81,323,338.88,322.65,345Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,348.57c5.28-1.24,10.84-1.21,16.21-1.12.12,0,.11.19,0,.19-5.33-.15-10.84,1.12-16.17,1.18A.13.13,0,0,1,332.35,348.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.48,357.68a14.24,14.24,0,0,1,3.69,0c1.31.09,2.61.2,3.91.33q3.92.39,7.8,1c.12,0,.12.2,0,.19-2.6-.25-5.2-.47-7.81-.62-1.31-.07-2.61-.13-3.92-.18a16.8,16.8,0,0,1-3.68-.32A.19.19,0,0,1,332.48,357.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91,368.82a9.79,9.79,0,0,1,3.32.16c1.19.15,2.38.28,3.56.41,2.38.26,4.75.52,7.13.7a.1.1,0,0,1,0,.19c-2.42-.17-4.85-.31-7.26-.5l-3.57-.29a9.1,9.1,0,0,1-3.2-.56C332.84,368.91,332.86,368.83,332.91,368.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,351.1l-9.79,38s47.44,15.12,53.07,3.21-20.24-58.6-35.85-72.37-10.59,6.88-10.18,8.53c1.82,7.33,11.07,26.7,11.07,26.7Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,344.86a9,9,0,0,0,0,6.2,8.7,8.7,0,0,0,.54-3.1A8.41,8.41,0,0,0,383,344.86Zm15.34,33.46a9,9,0,0,0,0,6.21,9.2,9.2,0,0,0,0-6.21Zm-16.46-8.77a8.26,8.26,0,0,0-3.1.55,9.2,9.2,0,0,0,6.21,0A8.27,8.27,0,0,0,381.9,369.55Zm1.49-45.34a8.22,8.22,0,0,0-2.57-1.81,9.12,9.12,0,0,0,4.39,4.39A8.3,8.3,0,0,0,383.39,324.21Zm32.86,65.23a8.39,8.39,0,0,0-2.57-1.81,8.61,8.61,0,0,0,1.81,2.59,8.41,8.41,0,0,0,2.58,1.8A8.3,8.3,0,0,0,416.25,389.44Zm-14.42-29.06a8.53,8.53,0,0,0-2.58-1.8,9,9,0,0,0,4.38,4.39A8.29,8.29,0,0,0,401.83,360.38Zm-23.42,31.25c-.27.3-.55.59-.8.91l1.13.28c.15-.14.31-.27.45-.41a8.69,8.69,0,0,0,1.81-2.58A8.58,8.58,0,0,0,378.41,391.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,351.17c5.42,2.24,19.51,10.23,22.53,13.37a.1.1,0,0,1-.12.16c-3-2.37-20.44-12.09-23.18-13.31,0,0-.15.34-.21.43s-.17,0-.16-.08a6.31,6.31,0,0,1,.25-.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.92,372.89c.66-2.65,3.24-13.29,3.68-16,0,0-.06-.06-.08,0-.92,2.49-3.77,12.9-4.44,15.56a149.16,149.16,0,0,0-3.54,16c0,.09.14.15.17,0C376.46,383.42,377.61,378.12,378.92,372.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.81,355.43c-1.33-3.35-3-6.56-4.49-9.85s-3-6.53-4.4-9.85c0-.05-.09,0-.07,0,.82,2.27,1.63,4.51,2.52,6.74-.29-.36-.55-.73-.81-1.11-.48-.68-.91-1.39-1.33-2.1,0,0-.09,0-.08,0a11.55,11.55,0,0,0,1.22,2.24,15.9,15.9,0,0,0,1.21,1.48c.37.91.74,1.81,1.14,2.71,1.47,3.32,2.57,6.59,4.53,9.66C383.32,355.51,383.86,355.54,383.81,355.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.35,396.3c-9.8,1.37-40.59-5.76-45.83-7.13.09-.56.09-.76.22-1.55,0-.1-.14-.16-.17-.05-.19.74-.78,2.22-.57,2.31,2.5,1.14,36.8,9,46.34,6.65C411.49,396.5,411.5,396.28,411.35,396.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.33 381.8 295.26 386.33 281.28 330.47 321.36 325.94 335.33 381.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.36 382.02 293.29 386.55 279.32 330.69 319.39 326.17 333.36 382.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.8,354.47a4.36,4.36,0,0,0,4.67,3.42,3.54,3.54,0,0,0,3.12-4.3,4.37,4.37,0,0,0-4.68-3.42A3.53,3.53,0,0,0,300.8,354.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,342.15c-1.76,4.64-6.66,10.61-6.8,14.3a4.22,4.22,0,0,0,2.69,4.27s-3.49,2.1-3.07,5.47c.21,1.73,3.17,2.91,3.17,2.91s-2.73,1.81-2.17,4.78c.44,2.37,3.34,3.19,3.34,3.19s-1.81,3-.58,5.23c2.48,4.59,23.09,2.94,25.66-4.9,1.2-3.66-3.81-3-3.81-3s7-2.72,6.74-7-6.69-3-6.69-3,6.73-2.69,6.05-7.07c-.72-4.57-7-2.2-7-2.2s4.34-3.47,3-6.71c-2.14-5.35-10.26,2.25-14.87,1.53l-3.1-7.26Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.86,349c1.29-4.54-4.61-9.54-4-14.06.82-6.11,8.05-.76,10.25,7.84l.54,7Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.07,377.27a.06.06,0,0,0,0,.11,35.78,35.78,0,0,0,21.12-3c.21-.1.13-.48-.12-.41A73.58,73.58,0,0,1,277.07,377.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.36,369.15c-.08,0-.08.13,0,.15,7.12,1.1,16-.16,22.84-4.67.23-.16.29-.53,0-.37C293.46,366.92,282,369.19,275.36,369.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44,354.71c-6.7,4.07-14,5.59-21.79,6.07-.1,0-.08.14,0,.16,3.85.8,8.76,0,12.53-1a20.55,20.55,0,0,0,9.39-5C297.68,354.85,297.58,354.62,297.44,354.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,330c4.38.17,10.3-7.64,12.11-13.38.12-.39-1.16-4-2.51-8.51-.81-2.73-1.64-5.79-2.2-8.63-.12-.59-17,7.85-17,7.85A46.15,46.15,0,0,1,357,317.9a7.22,7.22,0,0,1,.11,1.19,1.48,1.48,0,0,0,0,.2C357.19,321.58,358.48,329.83,362.71,330Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,299.76c.12,5-.58,17.18-10,19.27a10.94,10.94,0,0,1-1.85.26.7.7,0,0,1,0-.2,7.17,7.17,0,0,0-.1-1.19,46.64,46.64,0,0,0-3.89-10.59S365.29,301.23,369,299.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.14,280.76c1.83,6.48-2,25-6.64,29.08-6.77,5.88-17.66,6.23-22.61-1.87-4.79-7.85.59-31.93,5.79-35.6C357.34,267,370.44,271.17,373.14,280.76Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67,291.74s.08.09.07.14c-.34,1.23-.51,2.69.51,3.37,0,0,0,.09,0,.07C353.9,294.8,354.15,292.86,354.67,291.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.09,290.71c2,.33,1.23,4.37-.65,4.07S354.39,290.44,356.09,290.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.66,290.39c0-.05-.11,0-.12.09-.21,1.26-.66,2.67-1.87,2.86,0,0-.05.07,0,.07C347.09,293.49,347.67,291.62,347.66,290.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,288.86c-2-.55-2.94,3.46-1.1,4S348.46,289.33,346.8,288.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,288.46a15.38,15.38,0,0,1-1.46-.85,2.75,2.75,0,0,1-1.32-1.15.89.89,0,0,1,.34-1,2.17,2.17,0,0,1,2.18.19,3.18,3.18,0,0,1,1.53,1.7A.93.93,0,0,1,358,288.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.32,286.47a13.46,13.46,0,0,0,1.68,0,2.71,2.71,0,0,0,1.73-.29.86.86,0,0,0,.24-1,2.15,2.15,0,0,0-2-1,3.19,3.19,0,0,0-2.19.65A.93.93,0,0,0,345.32,286.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,303.43c-.25.34-.49.8-.94.9a3.38,3.38,0,0,1-1.41-.1,0,0,0,0,0,0,.07,1.72,1.72,0,0,0,1.71.44,1.35,1.35,0,0,0,.81-1.27C355.09,303.39,355,303.38,355,303.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.88,299.78a4.37,4.37,0,0,1-3.22,1.33,5.44,5.44,0,0,1-1.54-.24,1.4,1.4,0,0,1-.29-.09l-.27-.1a.31.31,0,0,1-.19-.33h0a.5.5,0,0,1,0-.13h0l0-.11c.17-1,.55-2.41.55-2.41-.38.1-2.34.55-2.21.06A65.3,65.3,0,0,1,351,285.19a.12.12,0,0,1,.22.07c-.87,4-2.45,7.81-3.39,11.82a7.39,7.39,0,0,1,2.13-.22c.13.07-.79,2.79-.83,3.23,0,0,0,0,0,0a6,6,0,0,0,4.68-.49C353.89,299.59,354,299.69,353.88,299.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.16,301a4.75,4.75,0,0,0,1.84,1.59,2.15,2.15,0,0,0,1.31.15c1-.2,1-1.07.9-1.82a5.06,5.06,0,0,0-.37-1.16A6.22,6.22,0,0,1,350.16,301Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,302.57a2.15,2.15,0,0,0,1.31.15c1-.2,1-1.07.9-1.82A2.24,2.24,0,0,0,352,302.57Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.87,295.27c-4.92.24-7.36-5.67-6.11-10.37,0,0-13.11,1.46-13.51-9a10.31,10.31,0,0,1-8.6,4.53l-1.54,3.83c-1.33-.41-2.68-4.25.66-7.17,0,0,.34-5.23,4.26-8.29a7.16,7.16,0,0,1,7.71-.91,10.84,10.84,0,0,1,7.92-1.78,9.23,9.23,0,0,1,6.7,5.16s6.44,1.37,7.45,6a9.56,9.56,0,0,1-1.44,7.66s1.59,1.84.68,5.75C377.47,293.14,375.35,295.2,373.87,295.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.56,274.93a12.19,12.19,0,0,0-.09,2.56,9.92,9.92,0,0,0,.43,2.49,6.59,6.59,0,0,0,2.94,3.83,10.62,10.62,0,0,0,4.79,1.31c.85,0,1.71.05,2.56,0s1.71-.15,2.57-.21c-.84.19-1.69.34-2.54.51s-1.73.12-2.6.18a10.57,10.57,0,0,1-5.09-1.26,6.9,6.9,0,0,1-3.08-4.22A10.32,10.32,0,0,1,354.56,274.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,280.85a13.57,13.57,0,0,0,4-2.05,8.23,8.23,0,0,0,1.56-1.56,10.25,10.25,0,0,0,1.14-2,5.47,5.47,0,0,1-.75,2.22,6,6,0,0,1-1.58,1.78,7.79,7.79,0,0,1-2.08,1.13A7,7,0,0,1,347.69,280.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.84,295.85s4.46-5.85,7.12-4.23-.85,10.2-4.11,11.26a3.26,3.26,0,0,1-4.29-1.93Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.89,294.05a0,0,0,0,1,0,.09c-2.29.82-3.56,2.85-4.48,5a1.81,1.81,0,0,1,2.72-.38c.05,0,0,.13-.07.12a2,2,0,0,0-2.23.6,9.51,9.51,0,0,0-1.13,1.75c-.12.19-.48.07-.39-.16l0-.05C369.41,298.13,371.8,294.21,374.89,294.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M361.76,297.58a.3.3,0,1,0,.59,0,.3.3,0,0,0-.31-.29A.3.3,0,0,0,361.76,297.58Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M355.52,297.56a.31.31,0,0,0,.31.29.3.3,0,0,0,.28-.32.29.29,0,0,0-.31-.28A.3.3,0,0,0,355.52,297.56Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M357.81,299.65a.3.3,0,1,0,.59,0,.29.29,0,0,0-.31-.29A.3.3,0,0,0,357.81,299.65Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M361.49,295.13a.3.3,0,0,0,.31.29.3.3,0,1,0-.31-.29Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M358.62,296.94a.3.3,0,0,0,.59,0,.3.3,0,0,0-.31-.29A.3.3,0,0,0,358.62,296.94Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.12,293.29a.3.3,0,0,0,.31.29.3.3,0,0,0,.28-.31.31.31,0,0,0-.31-.29A.3.3,0,0,0,343.12,293.29Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M345.51,294.88a.31.31,0,0,0,.31.29.3.3,0,0,0,.28-.31.3.3,0,0,0-.31-.29A.3.3,0,0,0,345.51,294.88Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M345,296.87a.3.3,0,0,0,.31.28.3.3,0,0,0,.29-.31.3.3,0,0,0-.31-.28A.29.29,0,0,0,345,296.87Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.92,295.59a.31.31,0,0,0,.31.29.3.3,0,0,0,.28-.31.3.3,0,0,0-.31-.29A.3.3,0,0,0,342.92,295.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434,252.89a24.67,24.67,0,0,1-39.38,19.81l-12.08,3.09,5-11.26A24.67,24.67,0,1,1,434,252.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,252.89a24.78,24.78,0,0,1-3.65,13,26.9,26.9,0,0,1-2,2.79,27.48,27.48,0,0,1-2.36,2.47,24.31,24.31,0,0,1-5.57,3.91,24.94,24.94,0,0,1-6.44,2.27,24.43,24.43,0,0,1-3.41.42,21.82,21.82,0,0,1-3.43,0A24.89,24.89,0,0,1,394.37,273l.3.06-12.06,3.16-.88.23.37-.83,5-11.27v.42a25,25,0,0,1-.77-22,25.25,25.25,0,0,1,6.83-9,25.14,25.14,0,0,1,21.27-5.16,25.2,25.2,0,0,1,10.07,4.81A24.87,24.87,0,0,1,434,252.89Zm0,0a24.4,24.4,0,0,0-30.61-23.64,24.2,24.2,0,0,0-9.71,5.06,25.44,25.44,0,0,0-6.5,8.78,24.28,24.28,0,0,0-2,10.7A24.72,24.72,0,0,0,388,264.3l.11.21-.09.22L382.9,276l-.51-.61,12.11-3,.16-.05.14.11a24.39,24.39,0,0,0,12.38,4.82,21.08,21.08,0,0,0,3.37.06,23.8,23.8,0,0,0,3.36-.36,24.1,24.1,0,0,0,6.4-2.13A22.86,22.86,0,0,0,425.9,271a28.52,28.52,0,0,0,2.36-2.43,27.86,27.86,0,0,0,2-2.77A24.7,24.7,0,0,0,434,252.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.57,239.34a9.45,9.45,0,1,0,13.36,0A9.46,9.46,0,0,0,408.57,239.34ZM420,243.76a1.77,1.77,0,0,1-2.5,0,1.79,1.79,0,0,1,0-2.5,1.77,1.77,0,0,1,2.5,0A1.75,1.75,0,0,1,420,243.76Z",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.91,
    y: 247.6,
    width: 2.85,
    height: 8.67,
    transform: "translate(-58.25 363.24) rotate(-45)",
    style: {
      fill: "#3B6AD7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.24 250.85 410.4 255.01 409.38 256.03 407.66 255.5 408.19 257.22 406.5 258.91 404.22 258.43 404.69 260.71 404.31 261.1 402.59 260.57 403.12 262.29 401.4 261.76 401.93 263.48 400.59 264.81 398.31 264.34 398.78 266.62 397.61 267.79 392.98 268.26 393.45 263.64 406.24 250.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.25,
    y: 259.13,
    width: 16.85,
    height: 0.41,
    transform: "translate(-65.73 359.98) rotate(-45)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.46,246a8.26,8.26,0,0,1-2.37,5.83,8.36,8.36,0,0,1-11.8.13,8.34,8.34,0,0,1,0-11.92,8.34,8.34,0,0,1,11.79.12A8.24,8.24,0,0,1,423.46,246Zm0,0a8.08,8.08,0,0,0-13.86-5.66A8.09,8.09,0,0,0,421,251.8,8.19,8.19,0,0,0,423.46,246Z",
    style: {
      opacity: 0.1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.d4338c5e2895d7e7541ea3d31e86d692.svg";
export { ForwardRef as ReactComponent };